import * as React from 'react';
import {Text} from 'wix-ui-tpa';
import {classes, st} from './TotalRow.st.css';
import {TotalsDataHook} from '../../Totals';

export interface TotalRowProps {
  title: string;
  value: string;
  className?: string;
  dataHook?: string;
}

export const TotalRow = ({title, value, className, dataHook}: TotalRowProps) => {
  return (
    <tr
      data-hook={dataHook ?? /* istanbul ignore next */ TotalsDataHook.TotalsRow}
      className={st(classes.root, className)}>
      <td className={classes.labelTextAlign}>
        <Text className={classes.totalTitleText} data-hook={TotalsDataHook.TotalsRowTitle}>
          {title}
        </Text>
      </td>
      <td className={classes.textAlign}>
        <Text className={classes.totalTitleValue} data-hook={TotalsDataHook.TotalsRowValue}>
          {value}
        </Text>
      </td>
    </tr>
  );
};

TotalRow.displayName = 'Totals.TotalRow';
